import { resolveIconPath } from "./utils/spot_utils";
import { logger } from "./utils/logger";

export const FALLBACK_ICON_KEY = "fallback";

export function buildCategoriesById(categories) {
  return categories.reduce((result, category) => {
    if (category?.id == null) return result;

    result[String(category.id)] = category;
    return result;
  }, {});
}

export function buildCategoryIcons(categories, imageBaseUrl = "") {
  const result = categories.reduce((acc, category) => {
    if (category?.id == null || !category?.image) return acc;

    const resolvedImage = resolveIconPath(category.image, "45", imageBaseUrl);
    if (!resolvedImage) return acc;

    acc[String(category.id)] = resolvedImage;
    return acc;
  }, {});

  // TODO: フォールバックアイコンが「その他」カテゴリであるという情報がフロントエンドとバックエンド二重管理になっている。dataタグで渡すなどして二重管理を解消したい
  const fallbackCategory = categories.find((c) => c.key === "other" && c.image);
  if (fallbackCategory) {
    const resolvedFallback = resolveIconPath(fallbackCategory.image, "45", imageBaseUrl);
    if (resolvedFallback) result[FALLBACK_ICON_KEY] = resolvedFallback;
  } else {
    logger.error("buildCategoryIcons: fallback categoryがない、またはfallback categoryにアイコンが設定されていない");
  }

  return result;
}
